import _ from 'lodash';
import { connect } from 'react-redux';
import { getStationDeliveriesForStation } from '../../modules/logistics/stationDelivery';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps)  => {

	const stationId = _.get(ownProps, ['station', 'stationId']);

	/** @namespace state.lists.stationDeliveriesForStation **/
	/** @namespace state.maps.stationDelivery **/
	/** @namespace state.maps.user **/
	let stationDeliveriesForStation = undefined;
	if (
		state.lists.stationDeliveriesForStation &&
		state.lists.stationDeliveriesForStation[stationId]
	) {
		stationDeliveriesForStation = _.map(state.lists.stationDeliveriesForStation[stationId],
			id => state.maps.stationDelivery[id]
		);
	}

	return {
		stationDeliveriesForStation,
		stationMap : state.maps.station,
		userMap : state.maps.user,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	getStationDeliveriesForStation,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);